import React from 'react';
import { CheckCircle } from 'lucide-react';
export function ResultsSection() {
  return <section className="bg-gray-50 py-12 md:py-16 px-4" data-id="element-152">
      <div className="max-w-4xl mx-auto text-center" data-id="element-153">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8" data-id="element-154">
          📊 RESULTADOS
        </h2>

        <div className="bg-purple-900 text-white rounded-lg p-8 md:p-12 mb-10" data-id="element-155">
          <p className="text-5xl md:text-6xl font-black mb-6" data-id="element-156">+12.847</p>
          <p className="text-xl md:text-2xl font-semibold mb-8" data-id="element-157">
            chicas ya lograron:
          </p>

          <div className="space-y-4 text-left max-w-2xl mx-auto" data-id="element-158">
            {['Dejar de pensar en él', 'Recuperarse en días (no meses)', 'Volver a sentirse seguras'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-159">
                <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" data-id="element-160" />
                <span className="text-lg font-semibold" data-id="element-161">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}